import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { api } from "@/lib/api";
import { Smartphone } from "lucide-react";

const PLAY_BADGE = "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";

// Reusable "Get the app" section — Google Play badge + scannable QR.
// variant="compact" for inline placement (e.g. blog posts).
export function GetTheApp({ variant = "full" }) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/site-config").then(({ data }) => setCfg(data)).catch(() => {}); }, []);

  if (!cfg || !cfg.app_promo_enabled || !cfg.play_store_url) return null;
  const compact = variant === "compact";

  return (
    <section className={`border border-[#27272A] bg-[#0F0F0F] ${compact ? "p-6" : "p-8 md:p-12"} relative overflow-hidden`} data-testid="get-the-app">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,51,31,0.12),transparent_60%)]" />
      <div className={`relative flex ${compact ? "flex-col sm:flex-row" : "flex-col md:flex-row"} items-center gap-8`}>
        <div className="flex-1 text-center md:text-left">
          <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[#FF331F] font-bold">
            <Smartphone className="h-4 w-4" /> Ronin Box App
          </div>
          <h3 className={`font-display uppercase tracking-tight text-white mt-3 ${compact ? "text-2xl" : "text-3xl md:text-4xl"}`}>
            Train anywhere with the Ronin Box app
          </h3>
          <p className="text-zinc-400 text-sm mt-3 max-w-md mx-auto md:mx-0">
            Voice-cued boxing workouts, round timer, and progress tracking — coached by Chris, right in your pocket.
          </p>
          <div className="mt-5 flex items-center gap-4 justify-center md:justify-start">
            <a href={cfg.play_store_url} target="_blank" rel="noreferrer" data-testid="get-app-play-badge" className="inline-block hover:opacity-90 transition-opacity">
              <img src={PLAY_BADGE} alt="Get it on Google Play" className="h-14" />
            </a>
            {cfg.app_store_url && (
              <a href={cfg.app_store_url} target="_blank" rel="noreferrer" data-testid="get-app-appstore" className="text-xs text-zinc-500 underline">App Store</a>
            )}
          </div>
        </div>
        <div className="shrink-0 text-center">
          <div className="bg-white p-3 rounded-lg inline-block" data-testid="get-app-qr">
            <QRCodeSVG value={cfg.play_store_url} size={compact ? 96 : 132} bgColor="#ffffff" fgColor="#0F0F0F" level="M" />
          </div>
          <p className="text-[10px] uppercase tracking-widest text-zinc-500 mt-2">Scan to install</p>
        </div>
      </div>
    </section>
  );
}
